export default "__VITE_ASSET__BTipqB4q__"